module.exports = __webpack_public_path__ + "img/img19.ae6bd3a4.png";